module.exports = __webpack_public_path__ + "static/Unmind-25b70976e734b42b4c7ae3762cfb9b97.jpg";